import { render } from "./FAQsNew.vue?vue&type=template&id=3a36af40"
const script = {}

import "./FAQsNew.vue?vue&type=style&index=0&id=3a36af40&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__